import React, { useContext, useEffect } from 'react';
import { AppContext } from './context/AppContext';
import ReturnHome from './ReturnHome';
import ResetFlags from './ResetFlags';

function SettingsMain(props) {
    const { FLAGS, setFlags, theme, setTheme, preferences, setPreferences } = useContext(AppContext);

    const toggleTheme = () => {
        console.log('old Theme was  ' + theme)

        if (theme === 'default') {
            setTheme('alt-theme')
        }
        else {
            setTheme('default')
        }
    };


    useEffect(() => {
        // every time I go to the main page, close the popup
        props.hideHamburger();
    }, [])

    function setTheTheme(themeName) {
        console.log(themeName)
    }

    const handlePrefChange = (e) => {
        const { name, value } = e.target;
        console.log("Changing Default Period" + name + value)
        setPreferences(prevStruct => ({
            ...prevStruct,
            [name]: value
        }));
    };

    const preferenceOptions = [
        { key: 'shotIncludesGoal', label: 'Shot Includes Goal' },
        { key: 'trackMisses', label: 'Track Misses' },
        { key: 'defaultPeriod', label: 'Default Period (min)', isToggle: false },
    ];

    return (
        <div>
            <h1>Settings Page</h1>
            <h3>Current Theme:</h3>
            <ul>
                <li onClick={() => setTheTheme('default')}>Default</li>
                {/* <li onClick={() => setTheme('retro')}>Retro</li> */}
                <li onClick={() => setTheTheme('light')}>Light</li>
                <li onClick={() => setTheTheme('dark')}>Dark</li></ul>
            <div>
                <button onClick={toggleTheme}>Toggle Theme</button>
                {/* Your app content */}
            </div>

            <table><tbody>
                {preferenceOptions.map(({ key, label, isToggle = true }) => (
                    <tr
                        key={key}
                        onClick={isToggle ? () =>
                            setPreferences(prev => ({
                                ...prev,
                                [key]: !prev[key],
                            })) : undefined} >
                        <td>{label}</td>
                        <td className="toggle-holder settingCell">
                            {isToggle ? (
                                <div className={`toggle-wrapper ${preferences[key] ? 'on' : 'off'}`}>
                                    <div className="toggle-circle"></div>
                                </div>
                            ) : (
                                <input type="number" className="settingCell"
                                    value={preferences[key]}
                                    onChange={e => setPreferences(prev => ({
                                        ...prev,
                                        [key]: e.target.value,
                                    }))
                                    } />)} </td>
                    </tr>
                ))}
            </tbody></table>
            <br />

            These flags are for testing/development purposes, not for general use <br />
            <table><tbody>
                {Object.keys(FLAGS).map(key => (
                    <tr key={key} onClick={
                        () => setFlags(prev => ({
                            ...prev,
                            [key]: !FLAGS[key]
                        }))}>
                        <td>{key}</td>
                        {/* <td>{FLAGS[key] ? 'True' : 'False'}</td> */}
                        <td className='toggle-holder'>
                            <div className={`toggle-wrapper ${FLAGS[key] ? 'on' : 'off'}`} >
                                <div className='toggle-circle'></div></div>
                        </td>

                    </tr>
                ))}
            </tbody></table>
            <ReturnHome />
            {(FLAGS.debug ? <ResetFlags /> : null)}
        </div >
    );
}

export default SettingsMain;